(function() {

    'use strict';

    /*global console:false */


    /**
     * Flash implementation for the VideoAbstract solution for HLS playback
     */
    var Feat = SAPO.Project.Video.Features,
        SWF  = SAPO.Utility.SWF;

    if (!Feat.hasFlash) { return; }



    /**
     * @since December 2014
     * @author jose.p.dias AT co.sapo.pt
     *
     * http://www.flashls.org/
     */

    /**
    TODO:
    * fix seek?
    * check other streams:
        * without parent playing
        * live one

    pl.getStreams().map(function(s){return s.name;}).join('\n')
    pl.setStream(0)
     */

    var pl;



    window.onHLSReady = function(/*id*/) {
        //console.log('onHLSReady', id);
        pl._onReady();
    };

    window.onManifest = function(duration) {
        //console.log('onManifest', duration);
        pl._duration = duration;

        pl.fire('durationchange');
        pl.fire('loadedmetadata');

        if (pl._startPlaying) {
            //console.log('ATTEMPT PLAY...');
            pl.play();
        }
    };

    window.onVideoSize = function(width, height) {
        //console.log('onVideoSize', width, height);
        pl._videoDimensions = [width, height];

        pl.fire('loadedmetadata');
    };

    window.onComplete = function(/*msg*/) {
        //console.log('onComplete', msg);
        pl.fire('ended');
    };

    window.onError = function(msg) {
        //console.log('onError', msg);
        pl._onError(msg);
    };


    window.onPosition = function(data) {
        // console.log('onPosition', data);
        pl._currentTime = data.position;
        pl.fire('timeupdate');
        //pl.fire('progress'); // TODO REQUIRED?
    };

    window.onState = function(state) {
        //console.log('onState', state);
        pl._state = state;

        var ev;
        switch (state) {
            case 'PAUSED':
            case 'PAUSED_BUFFERING':
                ev = 'pause';
                break;

            case 'PLAYING':
            case 'PLAYING_BUFFERING':
                ev = 'play';
                break;

            /*default:
                console.log('STATE: ' + state);*/
        }

        if (state.indexOf('_BUFFERING') !== -1) {
            //pl.fire('') // TODO trigger loading events?
        }

        if (ev) {
            pl.fire(ev);
        }
    };

    window.onSwitch = function(stream) {
        //console.log('onSwitch', stream);
        pl._stream = stream;
    };



    // video abstraction (uri is optional)
    var VideoFlashHLSImpl = function VideoFlashHLSImpl(o) {
        pl = this;
        window.top.pl = pl; // TODO TEMP

        if (o.src) {
            this._tmp = o.src;
        }

        this._options = o;

        this._handlers = {};
        this._volume = 1;
        this._videoDimensions = [1, 1];

        //console.log(flashvars);

        this._el = SWF.embed({
            swf:       '//' + SV_DOMAIN + ( window.location.port ? ( ':' + window.location.port ) : '' ) + '/Projects/Video/' + SV_VERSION + '/flash/flashlsChromeless.swf',
            dims:      o.dimensions,
            id:        this._id,
            container: o.container,
            params: {
                allowfullscreen:   true,        // if trueish, allowfullscreen param is set to true
                allowscriptaccess: 'always',    // allowscriptaccess param
                wmode:             'opaque',    // wmode param: opaque | transparent | window
                //bgcolor:           '#FF0000', // bgcolor param
                quality:           'high'     // quality param
            },
            flashvars: {},
            insteadOf: !!o.insteadOf
        });

        this._el.style.zIndex = 10000; // promote flash while not ready to let user click on flash blocker
        this._el.className = 'video fill';
    };

    VideoFlashHLSImpl.prototype = {
        // EVENTS

        addEventListener: function(evType, cb) {
            var bag = this._handlers[evType];
            if (!bag) {
                this._handlers[evType] = [cb];
            }
            else {
                bag.push(cb);
            }
        },

        removeEventListener: function(evType, cb) {
            var bag = this._handlers[evType];
            if (!bag) { return; }
            for (var i = 0, f = bag.length; i < f; ++i) {
                if (bag[i] === cb) {
                    bag.splice(i, 1);
                    --i;
                    --f;
                }
            }
        },

        fire: function(evType, val) {
            //console.warn('FIRE', evType, val);

            var bag = this._handlers[evType];

            var ev = {
                target:     this._el,
                srcElement: this._el,
                type:       evType
            };

            if (val !== undefined) {
                ev.value = val;
            }

            if (!bag) {
                return;
            }

            for (var i = 0, f = bag.length; i < f; ++i) {
                bag[i](ev);
            }
        },



        // LOAD AND PLAY STATE

        canAutoplay: function() {
            return true;
        },

        unload: function() {
            this._el.playerStop();
        },

        load: function(src, type, startPlaying) {
            this._startPlaying = !!startPlaying;
            this._el.playerLoad(src);
        },

        isPlaying: function() {
            return (
                this._state === 'PLAYING' ||
                this._state === 'PLAYING_BUFFERING'
            );
        },

        play: function() {
            this._el.playerPlay();
        },

        pause: function() {
            this._el.playerPause();
        },



        // TIME-RELATED

        getCurrentTime: function() {
            return this._currentTime;
        },

        setCurrentTime: function(/*t*/) {
            //this._el.playerSeek(t); // TODO NOT WORKING
        },

        getDuration: function() {
            return this._duration;
        },

        getCache: function(asRatio) {
            // TODO USE
            var d = (asRatio ? 1: this._duration);
            return {start:0, end:d, length:d};
        },

        isLive: function() {
            return !!this._isLive;
        },

        isReady: function() {
            return !!this._isReady;
        },



        // VOLUME-RELATED

        getVolume: function() {
            return this._volume;
        },

        setVolume: function(v) {
            this._volume = v;
            this._el.playerVolume(v*100);
        },



        // SIZE

        getVideoSize: function() {
            return this._videoDimensions;
        },



        // DOM

        getElement: function() {
            return this._el;
        },

        kill: function() {
            this._el.stop();
            this._el.parentNode.removeChild(this._el);
            pl = undefined;
        },



        // EXCLUSIVE!

        setStream: function(idx) {
            this._el.playerSetLevel(idx);
        },

        getStreamsLength: function() {
            return this._el.getLevels().length;
        },

        getStreams: function() {
            /*jshint boss:true */
            var streams = [];

            var v, k = 0;
            var levels = this._el.getLevels();

            function onLevel(l) {
                var name = (/([^\/]+)\.m3u8/).exec(l.url);
                name = (name ? name[1] : l.url);
                streams.push({
                    name:     name,
                    playlist: l.url,
                    bitRate:  ~~(l.bitrate / 1024),
                    size:     [l.width, l.height]
                });
            }

            while (v = levels[k]) {
                onLevel(v);
                ++k;
            }

            return streams;
        },



        // INTERNALS

        _onReady: function(/*id*/) {
            this._isReady = true;
            this._el.style.zIndex = '';

            if (this._options.onReady) { // call parent's onReady only once
                this._options.onReady(this);
                delete this._options.onReady;
            }

            this.fire('error', '');
            this.fire('impl_ready', 'flashhls');

            if (this._tmp) { // allow loading more than once - chrome apparently calls this function twice and isn't really ready for loading at the first time
                console.log('trying autoplay...');
                this.load(this._tmp);
                delete this._tmp;
            }
        },

        _onError: function(id, error) {
            console.log('onError', error);

            if (error === 'srcnotfound') {
                return this.fire('error', 'FLASH_SOURCE_NOT_FOUND');
            }

            this.fire('error', 'FLASH_GENERAL_ERROR');
        }
    };



    // this method is static and regular
    VideoFlashHLSImpl.canMimeTypeBePlayed = VideoFlashHLSImpl.prototype.canMimeTypeBePlayed = function(mimeType) {
        switch (mimeType) {
            case 'application/x-mpegurl':
            case 'application/vnd.apple.mpegurl':
                return true;

            default:
                return false;
        }
    };



    SAPO.namespace('Project.Video.Controllers');
    SAPO.Project.Video.Controllers.VideoFlashHLSImpl = VideoFlashHLSImpl;

    SAPO.Project.Video.Controllers.videoImpls['flashhls'] = VideoFlashHLSImpl;

})();
